import { HTMLAttributes } from 'react';

interface LoadingSpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Loading spinner component
 * Subtle dark mode spinner for async operations
 */
export function LoadingSpinner({
  size = 'md',
  className = '',
  ...props
}: LoadingSpinnerProps) {
  const sizeStyles = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-4',
  };
  
  const classes = `${sizeStyles[size]} border-muted-text border-t-primary-blue rounded-full animate-spin ${className}`.trim();
  
  return (
    <div className={classes} {...props} role="status" aria-label="Loading">
      <span className="sr-only">Loading...</span>
    </div>
  );
}












